<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Elomark User Type</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>User Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="usertype"
                v-model="usertypeDescription.usertype"
                v-validate="'required'"
                data-vv-as="User Type"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('usertype')"
              >{{ errors.first("usertype") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>User Type Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="usertype_description"
                v-model="usertypeDescription.usertype_description"
                v-validate="'required'"
                data-vv-as="User Type Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('usertype_description')"
              >{{ errors.first("usertype_description") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import moduleUserTypeManagement from "@/store/usertype-management/moduleUserTypeManagement.js";
import UserTypeAutocomplete from "@/components/autocomplete/UserTypeAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

     usertypeDescription : []
      }
  },
  components: {
    "v-select": vSelect,
    moduleUserTypeManagement,
    UserTypeAutocomplete
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });   
    if (!moduleUserTypeManagement.isRegistered) {
      this.$store.registerModule(
        "usertypesManagement",
        moduleUserTypeManagement
      );
      moduleUserTypeManagement.isRegistered = true;
    }
  },
  mounted() {
    console.log(this.$route.params)
    this.usertypeId = this.$route.params.usertypeId;
    this.init();

  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    init() {
      this.$store
        .dispatch("usertypesManagement/fetchUserType", this.usertypeId)
        .then(res => {
          this.usertypeDescription = res.data;
          if(this.usertypeDescription.is_client_usertype == 'y'){
            this.usertypeDescription.is_client_usertype = true
          }else{
            this.usertypeDescription.is_client_usertype = false
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
           if (this.usertypeDescription.is_client_usertype) {
          this.usertypeDescription.is_client_usertype = 'y'
        } else {
          this.usertypeDescription.is_client_usertype = 'n'
        }

          this.updateUserType();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    updateUserType() {
      this.$store
        .dispatch(
          "usertypesManagement/updateUserType",
          this.usertypeDescription
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Elomark User Updated",
              text: "The user was updated successfully"
            });
            this.$router.push({ path: "/usertypes" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
